import {configureStore} from "@reduxjs/toolkit";
import {authReducer} from "features/auth/authSlice";
import {loginReducer} from "features/auth/loginSlice";
import {i18nReducer} from "features/i18n/i18nSlice";
import {menuReducer} from "features/menu/menuSlice";
import {winePickerReducer} from "features/winepicker/winePickerSlice";
import {menuEditorReducer} from "features/editor/editorSlice";
import {choseCustomerReducer} from "features/auth/choseCustomerSlice";
import {algoliaCredentialsReducer} from "features/algolia/algoliaCredentialsSlice";
import { labelEditorReducer } from "features/label-editor/labelEditorSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        login: loginReducer,
        algoliaCredentials: algoliaCredentialsReducer,
        choseCustomer: choseCustomerReducer,
        i18n: i18nReducer,
        menu: menuReducer,
        winePicker: winePickerReducer,
        menuEditor: menuEditorReducer,
        labelEditor: labelEditorReducer,
    }
});

export type AppStore = typeof store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch